/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const SettingBusinessPage = lazyLoad(
  () => import('./index'),
  module => module.SettingBusinessPage
);
